import React from 'react'
import cx from 'classnames'
import { Icon, isMobile } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { FlowContextMenu } from 'apps/cms/components/FlowContextMenu/FlowContextMenu'
import { useExternalFlowCard } from 'apps/cms/components/Flows/hooks/useExternalFlowCard'
import { useFlowCardDrag } from 'apps/cms/components/Flows/hooks/useFlowCardDrag'
import { FlowCardClickAction } from 'apps/cms/pages/ContentManagementSystem/lib/types'
import { contentManagementSelectors } from 'apps/cms/store'
import { PermissionTargets, usePermission } from 'common/userRoles'
import { FsFlow } from 'shared/api/requests/cms/schemas'
import { useDndRef } from 'utils/commonHooks'

import iconGridMark from '../../assets/iconGridMark.svg'

import cm from './FlowCompactCard.module.css'

interface ExternalFlowCompactCardProps {
  flow: FsFlow
}

export const ExternalFlowCompactCard = ({ flow }: ExternalFlowCompactCardProps) => {
  const { handleFlowCardClick, isCardDisabled, errorMessage, cardActionAriaLabel } =
    useExternalFlowCard({
      flow,
    })
  const userCanEditFlow = usePermission(PermissionTargets.FLOW_EDITING)
  const { connectDragSource } = useFlowCardDrag({ flow })
  const dragRef = useDndRef(connectDragSource)
  const {
    showFlowContextMenu,
    allowHoverFlowCard,
    allowHighlightActiveFlowCard,
    lastSelectedFlowId,
    flowCardClickAction,
  } = useAppSelector(contentManagementSelectors.getUi)
  const isFlowCardActive = lastSelectedFlowId === flow.ns && allowHighlightActiveFlowCard
  const showArrow = flowCardClickAction === FlowCardClickAction.OPEN_FLOW

  return (
    <article
      ref={dragRef}
      className={cx(cm.flowCompactCard, {
        [cm.card_disabled]: isCardDisabled,
        [cm.card_withHover]: allowHoverFlowCard,
        [cm.card_active]: isFlowCardActive,
      })}
      data-title-at="top"
      data-title={isCardDisabled && errorMessage && !isMobile ? errorMessage : undefined}
    >
      {showArrow && (
        <button
          onClick={handleFlowCardClick}
          type="button"
          className={cm.flowCompactCard__mainActionButton}
          aria-label={cardActionAriaLabel}
        />
      )}

      {flowCardClickAction === FlowCardClickAction.SAVE_FLOW_ID_TO_STATE && (
        <button
          onClick={handleFlowCardClick}
          type="button"
          className={cm.flowCompactCard__mainActionButton}
          aria-label={cardActionAriaLabel}
        />
      )}

      <div className={cm.flowCompactCard__placeholder}>
        <img src={iconGridMark} alt="" />
      </div>

      <div className={cm.flowCompactCard__footer}>
        <div className={cm.flowCompactCard__title}>
          <h1 className={cx(cm.flowCompactCard__flowName, 'text-ellipsis')}>{flow.name}</h1>
        </div>

        <div className={cm.flowCompactCard__actions}>
          {showArrow && (
            <span className="d-flex text-default m-r-sm" aria-hidden="true">
              <Icon.ArrowTopRight size={20} />
            </span>
          )}

          {userCanEditFlow && showFlowContextMenu && (
            <FlowContextMenu
              anchorClassName={cm.flowCompactCard__interactableElement}
              flowPath={flow.path}
            />
          )}
        </div>
      </div>
    </article>
  )
}
